import { OnlineTimeAppLast12Months } from 'Consts/types';

import * as api from 'Api/endpoints';

import type { RootState, Action } from 'State/store';
import { createStandardSlice } from 'State/utils';

const slice = createStandardSlice<OnlineTimeAppLast12Months>(
  'personsLast12MonthsAppsOnlineTime'
);

const fetchData = (personId: string): Action => {
  return async (dispatch, getState) => {
    const { activeLocation } = getState().locations;
    const customerId = activeLocation?.customerId;
    const { data: token } = getState().locations.activeLocation
      ?.accessedAsCoAdminLocation
      ? getState().auth.coAdminData
      : getState().auth.data;
    const cloud = getState().auth.cloud;
    const personLast12MonthsOnlineTime =
      getState().appsOnlineTime.employee.last12months;

    if (
      personLast12MonthsOnlineTime.isLoading ||
      !personId ||
      !customerId ||
      !token ||
      !activeLocation?.id
    ) {
      return;
    }

    dispatch(actions.isLoading(true));

    const { data, error } = await api.getPersonLast12MonthsOnlineAppTime({
      customerId,
      locationId: activeLocation.id,
      personId,
      token,
      cloud,
    });

    if (error || !data) {
      dispatch(
        actions.error(error?.message || 'Error fetching Apps online time')
      );

      return;
    }

    dispatch(actions.set(data.last12Months));
  };
};

export const selectors = (state: RootState) =>
  state.appsOnlineTime.persons.last12months;

export const actions = {
  ...slice.actions,
  fetchData,
};

export default slice.reducer;
